module.exports = __webpack_public_path__ + "static/flags/PM-80e439f4a8761dba45dde026defc5a48.gif";